import { Box, Button, Flex } from "@mantine/core"
import { FunnelIcon } from "@phosphor-icons/react";
import { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import { FilterChip, FilterChipData } from "./filter-chip"
import { GroupByMenu, GroupByOption } from "./group-by-menu"
import { OdooSearchBar } from "./search-bar"
import { ViewSwitcher } from "./view-switcher"

type Props = {
  searchValue?: string
  onSearchChange?: (value: string) => void
  onSearch?: (value: string) => void
  filterChips?: FilterChipData[]
  onFilterClick?: () => void
  filterOpen?: boolean
  viewMode?: "list" | "kanban"
  onViewChange?: (mode: "list" | "kanban") => void
  kanbanBadge?: number
  groupByOptions?: GroupByOption[]
  activeGroupBy?: string | null
  onGroupByChange?: (key: string | null) => void
  extraActions?: ReactNode
  inlineFilters?: ReactNode
}

export function ControlPanel({
  searchValue,
  onSearchChange,
  onSearch,
  filterChips = [],
  onFilterClick,
  filterOpen,
  viewMode = "list",
  onViewChange,
  kanbanBadge = 0,
  groupByOptions = [],
  activeGroupBy = null,
  onGroupByChange,
  extraActions,
  inlineFilters,
}: Props) {
  const { t } = useTranslation("common")

  return (
    <Box>
      <Flex align="center" justify="space-between" gap="sm" wrap="wrap">
        <Flex gap="sm" style={{ flex: 1 }} wrap="wrap" align="center">
          <Box style={{ flex: 1, minWidth: 240 }}>
            <OdooSearchBar value={searchValue} onChange={onSearchChange} onSearch={onSearch} />
          </Box>
          {inlineFilters}
          <Button
            variant={filterOpen ? "filled" : "default"}
            color={filterOpen ? "dark" : undefined}
            size="sm"
            radius="md"
            leftSection={<FunnelIcon size={16} />}
            onClick={onFilterClick}
          >
            {t("actions.filter")}
          </Button>
          {groupByOptions.length > 0 && onGroupByChange && (
            <GroupByMenu options={groupByOptions} active={activeGroupBy} onChange={onGroupByChange} />
          )}
        </Flex>
        <Flex gap="sm">
          {extraActions}
          {onViewChange && <ViewSwitcher mode={viewMode} onChange={onViewChange} kanbanBadge={kanbanBadge} />}
        </Flex>
      </Flex>
      {filterChips.length > 0 && (
        <Flex gap="xs" mt="sm">
          {filterChips.map((chip) => (
            <FilterChip {...chip} />
          ))}
        </Flex>
      )}
    </Box>
  )
}
